import { create } from "zustand";
import {
  callingPlateform,
  coach_waba_count,
  order_related,
  slot_booking_audit,
} from "../api_layer/api";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";

export const userCallings = create((set) => ({
  callingData: [],
  callingAuditData: {},
  coachWabaData: {},
  orderCoachData: {},
  orderCoachLoading: false,
  coochWabaLoading: false,
  isLoading: false,
  auditLoading: false,
  isError: false,
  errorMessage: "",
  getCallingData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await callingPlateform();
      set({ callingData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ isLoading: false });
    }
  },
  getAuditData: async (agentId = secureLocalStorage.getItem("id"), date=moment().format('YYYY-MM-DD')) => {
    try {
      set({ auditLoading: true, error: null });
      const response = await slot_booking_audit(agentId, date);
      set({ callingAuditData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ auditLoading: false });
    }
  },
  getCoachWabaData: async (agentId = secureLocalStorage.getItem("id"), date=moment().format('YYYY-MM-DD')) => {
    try {
      set({ coachWabaLoading: true, error: null });
      const response = await coach_waba_count(agentId, date);
      set({ coachWabaData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ coachWabaLoading: false });
    }
  },
  getCoachOrderData: async (agentId = secureLocalStorage.getItem("id"), date=date=moment().format('YYYY-MM-DD')) => {
    try {
      set({ orderCoachLoading: true, error: null });
      const response = await order_related(agentId, date);
      set({ orderCoachData: response.data });
    } catch (error) {
      console.error(error);
      set({ error: error?.message });
    } finally {
      set({ orderCoachLoading: false });
    }
  },
}));
